import { useSelector } from 'react-redux';

import { inquiriesListSelector } from '@store/features/inquiries/list/selectors';
import { TInquiriesListKey } from '@store/features/inquiries/list/slice.interface';

import { getInquirySupplementsFromList } from './utils';

const useShareInquirySupplements = (inquiryId: number | null) => {
  const completeInquiriesList = useSelector(inquiriesListSelector(TInquiriesListKey.Complete));

  const inquirySupplements = inquiryId
    ? getInquirySupplementsFromList(completeInquiriesList, inquiryId)
    : [];

  return inquirySupplements.filter(item => item.isActive);
};

export default useShareInquirySupplements;
